import {
  DATE_PRESET_OPTIONS,
  DatePresetId,
  resolveDatePreset,
} from '../../reports/helpers/date-presets.helper';
import {
  DateRange,
  PeriodOption,
} from '../components/date-range-picker/date-range-picker.component';

/** DateRangePickerComponent treats exactly 'Custom' as the draft/custom-range option. */
export const EXPORT_CUSTOM_PERIOD = 'Custom';

const NAMED_PRESETS = DATE_PRESET_OPTIONS.filter(option => option.id !== 'custom');

/** CWS-1637: every CSV export offers the same presets as Reports, plus a custom range. */
export const EXPORT_PERIOD_OPTIONS: PeriodOption[] = [
  ...NAMED_PRESETS.map(option => ({ label: option.label, value: option.id })),
  { label: 'Custom Range', value: EXPORT_CUSTOM_PERIOD },
];

const PRESET_IDS = new Set<string>(NAMED_PRESETS.map(option => option.id));

/**
 * Resolve a picker selection to calendar dates. Presets resolve in `timeZone` (the shop
 * zone the API also uses via `x-timezone`), so "Today" means the shop's today.
 */
export function resolveExportDateRange(
  period: string,
  customRange: DateRange | undefined,
  timeZone: string | undefined,
  now: Date = new Date()
): { startDate: Date; endDate: Date } | null {
  if (period === EXPORT_CUSTOM_PERIOD) {
    if (!customRange?.startDate || !customRange.endDate) {
      return null;
    }
    return { startDate: new Date(customRange.startDate), endDate: new Date(customRange.endDate) };
  }
  const range = PRESET_IDS.has(period)
    ? resolveDatePreset(period as DatePresetId, now, timeZone || undefined)
    : null;
  return range ? { startDate: range.start, endDate: range.end } : null;
}
